module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (177).ca2644cc.jpg";